// noinspection JSUnusedGlobalSymbols

import { getFavoritesFromStorage } from '../services/favorites';
import {
    getFirstAidKit,
    getFirstAidKitFromStorage
} from '../services/firstAidKit';
import {
    addDocumentToMyDocuments,
    removeMyDocumentFromStorageById
} from '../services/myDocuments';
import service from '../services/user';
import { createReducerFor } from './utils';

const TYPE = 'prefs';

export const prefAction =
    (fn) =>
        (...params) =>
            async (dispatch, getState) => {
                let data = null;
                let error = null;
                try {
                    const {
                        hashKey,
                        me,
                        storeKey,
                    } = getState?.()?.user?.info ?? {};
                    //
                    dispatch({
                        type: TYPE,
                        payload: { isLoading: true },
                    });
                    data = await fn(...params);
                    const fullFavorites = (await getFavoritesFromStorage(me?.profileId, hashKey)) || [];
                    try {
                        data.fullFavorites = fullFavorites;
                    } catch (e) {
                        console.warn('Error set fullFavorites', {
                            data,
                            fullFavorites,
                        });
                    }
                    const {
                        basket,
                        drugSearch,
                    } = await getFirstAidKit({
                        me,
                        hashKey,
                        storeKey,
                    });
                    // console.log('prefAction: for drugs', {
                    //     params,
                    //     data,
                    //     basket,
                    //     // drugSearch,
                    // });
                    try {
                        data.basket = basket || [];
                        data.drugsSearch = drugSearch || [];
                    } catch (e) {
                        console.warn('Error set prefs data', {
                            data,
                            basket,
                            drugSearch,
                        });
                    }
                } catch (ex) {
                    error = ex;
                } finally {
                    dispatch({
                        type: TYPE,
                        payload: {
                            error,
                            data,
                            isLoading: false,
                        },
                    });
                }
            };

export const updatePreference = prefAction(service.updatePreference);
export const clearPreferences = prefAction(() => {
});

// marks
// export const setMarksOnceProgram = flag => updatePreference(
//     'onceProgram',
//     () => flag
// );

// favorites (for old solution)
// export const toggleFavorites = id => updatePreference(
//     'favorites',
//     (items = []) => (items.includes(id) ? items.filter(e => e !== id) : [...items, id]),
// );

// export const updateFavoritesList = data => updatePreference(
//     'favorites',
//     () => (data),
// );

// export const addToFavorites = id => updatePreference(
//     'favorites',
//     (items = []) => (items.includes(id) ? [...items] : [...items, id]),
// );
// export const removeFromFavorites = id => updatePreference(
//     'favorites',
//     (items = []) => ([...items.filter(e => e !== id)]),
// );

// new favorites (new solution)

export const updateFullFavoritesList = (data) => {
    return updatePreference('fullFavorites', () => data);
    // updateFavoritesList(data.map(e => e.id));
};

export const toggleFullFavorites = (item) => {
    // toggleFavorites(item.id);
    return updatePreference('fullFavorites', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();
        const itemsLocal = (await getFavoritesFromStorage(me?.profileId, hashKey)) || [];
        return itemsLocal.some((e) => e.id === item.id)
            ? itemsLocal.filter((e) => e.id !== item.id)
            : [ ...itemsLocal, item ];
    });
};

export const addFullFavorites = (item) => {
    // addToFavorites(item.id);
    return updatePreference('fullFavorites', (items = []) =>
        items.some(({ id }) => item?.id === id) ? [ ...items ] : [ ...items, item ],
    );
};

export const setICloudEnabled = (enabled) => updatePreference('iCloudEnabled', () => enabled);
export const setGoogleCloudEnabled = (enabled) => updatePreference('googleCloudEnabled', () => enabled);

export const setBackupVisitAttachmentsEnabled = (enabled) => updatePreference('backupVisitAttachments', () => enabled);
export const setBackupMyDocsEnabled = (enabled) => updatePreference('backupMyDocs', () => enabled);
export const setBackupAttachmentsWifiEnabled = (enabled) => updatePreference('backupAttachmentsWifi', () => enabled);

// Basket
export const toggleBasket = (item) =>
    updatePreference('basket', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();

        const { basket: items } = (await getFirstAidKitFromStorage({
            hashKey,
            profileId: me?.profileId,
        })) || [];

        return items.some((e) => e.id === item.id) ? items.filter(({ id }) => id !== item.id) : [ ...items, item ];
    },
    );

// Drugs
export const deleteSearchHistory = (item) =>
    updatePreference('drugsSearch', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();
        const { drugSearch: items } = (await getFirstAidKitFromStorage({
            hashKey,
            profileId: me?.profileId,
        })) || [];
        return items.filter(({ id }) => id !== item?.id);
    });

export const addDrugInHistory = (item) =>
    updatePreference('drugsSearch', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();
        const { drugSearch: items } = (await getFirstAidKitFromStorage({
            hashKey,
            profileId: me?.profileId,
        })) || [];
        return [ item, ...items.filter(({ key }) => key !== item.key) ].slice(0, 8);
    });

export const setProgram = (item) => updatePreference('program', () => item);

export const setUserAgreementIsSigned = (v) => updatePreference('isUserAgreementSigned', () => v);

export const addDocument = (doc) => {
    addDocumentToMyDocuments({ document: doc });
};
// export const addDocument = (doc) => updatePreference('documents', (items = []) => {
//     addDocumentToMyDocuments({ document: doc });
//     return [ ...items, doc ];
// });

export const removeDocument = (docId) =>
    updatePreference('documents', (items = []) => {
        removeMyDocumentFromStorageById({ id: docId })
            .catch((e) => console.warn(`removeDocument error ${docId}`, e))
            .then((docs) => console.log('removeDocument done', docs));
        return items.filter(({ id }) => id !== docId);
    });

export const updatePrefs = prefAction((obj) => obj);

export const updateDocFilters = (docFilters, from = '') =>
    updatePreference(`docFilters${from}`, (oldFilters) => ({
        ...oldFilters,
        ...docFilters,
    }));
export const changeBasketQty = (item, qty = 1) =>
    updatePreference('basket', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();

        const { basket: items } = (await getFirstAidKitFromStorage({
            hashKey,
            profileId: me?.profileId,
        })) || [];
        return items.map((i) => ({
            ...i,
            qty: i?.id === item?.id ? qty : i?.qty,
        }));
    },
        // items.map((i) => ({
        //     ...i,
        //     qty: i?.id === item?.id ? qty : i?.qty,
        // })),
    );

export const changeSelectInBasket = (item, selected = true) =>
    updatePreference('basket', async () => {
        const {
            me,
            hashKey,
        } = await service.getUserInfo();

        const { basket: items } = (await getFirstAidKitFromStorage({
            hashKey,
            profileId: me?.profileId,
        })) || [];
        return items.map((i) => ({
            ...i,
            selected: i?.id === item?.id ? selected : i?.selected,
        }));
    });

export const changeSelectionInBasket = (i) => updatePreference('basket', () => [ ...i ]);

export const updateBasket = (basket) =>
    updatePreference('basket', (b) => {
        console.log('updateBasket', {
            basket,
            b,
        });
        return b;
    });
export const updateDrugsSearch = (drugsSearch) =>
    updatePreference('drugsSearch', (s) => {
        console.log('updateDrugsSearch', {
            drugsSearch,
            s,
        });
        return s;
    });

export default createReducerFor(TYPE);
